<template>
  <b-form-textarea
    v-model="internal"
    v-bind="$attrs"
  />
</template>

<script>
export default {
  name: 'InputNestedObject',
  inheritAttrs: false,
  props: {
    value: [Object, Array],
  },
  computed: {
    internal: {
      get() {
        return JSON.stringify(this.value, null, 2)
      },
      set(val) {
        try {
          const result = val === '' ? undefined : JSON.parse(val)
          this.$emit('input', result)
        } catch (err) {
          this.$emit('error', err)
        }
      },
    },
  },
}
</script>
